module.exports = __webpack_public_path__ + "img/dialog-order.402a9448.svg";